import { ISO_CURRENCY_CODE_STRING_MAP } from '@policyfly/utils/constants'

import type { ISOCurrencyCode } from '@policyfly/protobuf'

export function isoCurrencyCodeToString (code: ISOCurrencyCode): string {
  return ISO_CURRENCY_CODE_STRING_MAP.get(code) ?? ''
}
